module.exports = __webpack_public_path__ + "static/media/bg.4da1c027.png";